import { uiContext } from "@/components/UiProvider";
import { useContext } from "react";

const useUiSelector = (fn) => {
  const { uiState } = useContext(uiContext);
  return fn(uiState);
};

export default useUiSelector;
